import { IRootState } from '@/store';
import { ActionTree } from 'vuex';
import { ITakeTeilnehmerState } from './state';

import { LOADING_TEILNEHMER, OFFSET_TEILNEHMER, TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, ADD_TEILNEHMERLIST, MAP_TEILNEHMERLIST } from './mutations';
import { NAME } from './';

import { takeTeilnehmerService } from '../services/TakeTeilnehmerService';
import { NEW_SUCESS } from '@/store/modules/headerNotification/actions';
import { GET_PERMISSIONS, GET_BENUTZERINFO } from '@/store/modules/security/actions';
import { SHOW, HIDE } from '@/store/modules/loadingSpinner/actions';
import { TakeTeilnehmerApiDto } from '@/api-schema';
import { securityService } from '@/services/securityService';

export const TAKESPECIFIC = 'TakeSpecific';
export const RESET = 'Reset';
export const GET_TEILNEHMER = 'GetTeilnehmer';
export const GET_NEXT_TEILNEHMER = 'GetNextTeilnehmer';

export const actions: ActionTree<ITakeTeilnehmerState, IRootState> = {
    async [TAKESPECIFIC]({ dispatch }: any, teilnehmer: TakeTeilnehmerApiDto) {
        console.debug(NAME + '::' + TAKESPECIFIC);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await takeTeilnehmerService.takeSpecific(teilnehmer).then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            console.log('permissions loaded after setting specific user');
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch(
                'headerNotification/' + NEW_SUCESS,
                {
                    text:
                        'Rolle wurde erfolgreich gewechselt mit TeilnehmerId: ' +
                        teilnehmer.teilnehmerId +
                        ' bzw. tvsKundennummer: ' +
                        teilnehmer.tvsKundennummer +
                        ' und Rolle: ' +
                        teilnehmer.benutzerRolle
                },
                { root: true }
            );
        });
    },

    async [RESET]({ dispatch }: any) {
        console.debug(NAME + '::' + RESET);

        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        await securityService.resetContext().then(async () => {
            //Reload Permissions
            await dispatch('security/' + GET_PERMISSIONS, {}, { root: true });
            await dispatch('security/' + GET_BENUTZERINFO, {}, { root: true });
            dispatch('loadingSpinner/' + HIDE, {}, { root: true });
            dispatch('headerNotification/' + NEW_SUCESS, { text: 'Rolle erfolgreich zurückgesetzt' }, { root: true });
        });
    },

    async [GET_NEXT_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_NEXT_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, state.teilnehmerList.length);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(ADD_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    },
    async [GET_TEILNEHMER]({ commit, state }: any) {
        console.debug(NAME + '::' + GET_TEILNEHMER);

        if (state.teilnehmerLoading || (state.teilnehmerFilter.offset !== 0 && state.teilnehmerFilter.offset >= state.teilnehmerTotalNumberOfRecords)) {
            return;
        }

        commit(LOADING_TEILNEHMER, true);
        commit(OFFSET_TEILNEHMER, 0);

        await takeTeilnehmerService.getTeilnehmer(state.teilnehmerFilter).then((response) => {
            commit(TOTAL_NUMBER_OF_RECORDS_TEILNEHMER, response.totalNumberOfRecords);
            commit(MAP_TEILNEHMERLIST, response.entries);
            commit(LOADING_TEILNEHMER, false);
        });
    }
};
